import React from 'react'

const CircleTickGreyIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5059_43457)">
                <path d="M12.7172 5.83272C12.9836 7.14014 12.7937 8.49938 12.1793 9.68376C11.5648 10.8681 10.5629 11.8061 9.34057 12.3412C8.11826 12.8762 6.74947 12.9761 5.46244 12.6241C4.17542 12.2721 3.04796 11.4895 2.2681 10.4069C1.48823 9.32423 1.10309 8.00694 1.17691 6.67469C1.25072 5.34245 1.77903 4.07577 2.67373 3.0859C3.56843 2.09603 4.77544 1.4428 6.09347 1.23515C7.41151 1.02749 8.76089 1.27797 9.9166 1.9448" stroke="#808080" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.25 6.41146L7 8.16146L12.8333 2.32812" stroke="#808080" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_5059_43457">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CircleTickGreyIcon
